import React from "react";
// Components
import HorizontalCard from "../generic/HorizontalCard";
// Styled
import styled from "styled-components";
// React Router
import { useHistory } from "react-router-dom";

const CardAddHermana = styled(HorizontalCard)`
    background-color: aliceblue;
    :hover {
        box-shadow: 0 0px 6px #2a599f !important;
    }
`;

const HermanaAddTarjeta = ({ ...props }) => {

    let history = useHistory();

    let img = "/images/nun.png";
    let imgOnError = img;
    let title = `Añadir una nueva hermana`;

    return (
        <CardAddHermana onClick={() => {
            history.push(`hermanas/add`);
        }} cardImage={img} title={title} imgOnError={imgOnError} {...props}>
        </CardAddHermana>
    );
};

export default HermanaAddTarjeta;
